/**
 * Fetches the sourcecode from browser session storage
 *
 * @return {string} The actual sourcecode or null if there is none
 */
const fetchSourceCodeFromLocalStorage = () => {
  const sourcecode = sessionStorage.getItem("sourcecode");

  if (sourcecode !== null) {
    return sourcecode;
  }

  return false;
};

export default fetchSourceCodeFromLocalStorage;
